<!--
INTELLECTUAL PROPERTY NOTICE
© Kaleida Ltd. All rights reserved.
This file contains Protected Intellectual Property owned by Kaleida Ltd and forms part of an application developed by Kaleida within the Platform.
Protected Intellectual Property may only be used as incorporated within applications developed by Kaleida within the Platform and must not be used, reproduced, adapted, or incorporated into any application developed by or on behalf of the Customer (explicitly not developed by Kaleida), whether or not such application forms part of the Platform.
For the avoidance of doubt, the inclusion of any application within the Platform does not of itself grant any right to use Protected Intellectual Property in that application unless that application was developed by Kaleida.
-->
<!-- IP-NOTICE: PROTECTED -->
<div [ngClass]="displayChildInRow ? 'content flex-layout-row' : 'flex-layout-column'">
	<div [ngClass]="masterWidthClass">
		<mat-card *ngIf="hasFilterContent">
			<mat-card-content>
				<div class="h3masterchild" *ngIf="hasTitle">{{ filterTitle }}</div>
				<div style="float: left">
					<ng-content select=".filterContent"></ng-content>
				</div>
			</mat-card-content>
		</mat-card>

		<ng-container *ngIf="masterDisplayedInMatCard; else masterNoCard">
			<mat-card [ngClass]="displayChildInRow ? masterHeight : 'column-master-height'">
				<mat-card-content>
					<ng-container *ngTemplateOutlet="masterContent"></ng-container>
				</mat-card-content>
			</mat-card>
		</ng-container>
		<ng-template #masterNoCard>
			<div [ngClass]="displayChildInRow ? masterHeight : 'column-master-height'">
				<ng-container *ngTemplateOutlet="masterContent"></ng-container>
			</div>
		</ng-template>
	</div>

	<ng-template #masterContent>
		<ng-content select=".listContent"></ng-content>
	</ng-template>

	<ng-template #content>
		<ng-content masterChildView (itemDeleted)="onChildItemDeleted($event)" select=".detailContent"></ng-content>
	</ng-template>

	<div [ngClass]="childWidthClass">
		<div *ngIf="childDisplayedInMatCard">
			<mat-card class="child">
				<mat-card-content>
					<ng-container *ngTemplateOutlet="content"></ng-container>
				</mat-card-content>
			</mat-card>
		</div>
		<div *ngIf="!childDisplayedInMatCard">
			<ng-container *ngTemplateOutlet="content"></ng-container>
		</div>
	</div>
</div>
